import 'isomorphic-fetch';

interface FetchCarImageProps {
  readonly faServicesUrl: string;
  readonly vin: string;
}

export const fetchCarImage = async ({ faServicesUrl, vin }: FetchCarImageProps) => {
  if (!vin) return null;

  const params = new URLSearchParams();

  params.set('vin', vin);

  const url: string = `${faServicesUrl}/vehicleImage?${params.toString()}`;

  const response = await fetch(url)
  const imageBlob = await response.blob();

  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(imageBlob);
  })
}